import React from "react";

interface Props {
  size?: number;
}

const PlusIcon = ({ size = 16 }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 16"
    >
      <path stroke="currentColor" d="M8 0v16M0 8h16"></path>
    </svg>
  );
};

export default PlusIcon;
